import { defineStore } from 'pinia'
import { ref } from 'vue'

// Exactly one of the two ids, mirroring a SegmentRun. Both null is "All
// clients". The whole query is null when the page shows filters that no saved
// query matches, and then no row of the navbar query picker is the page's own.
export type PageQuery = {
  segmentId: number | null
  partnerSegmentId: number | null
}

// The Insights companies page writes which query it shows and whether it still
// waits on that query's results. The navbar query picker cannot read either
// from the URL: the page updates the URL a tick after the run starts, and a
// query switched inside the page never reloads the picker.
export const useInsightsPageRun = defineStore('insightsPageRun', () => {
  const running = ref(false)
  const query = ref<PageQuery | null>(null)

  function setPageRun(next: {
    running: boolean
    query: PageQuery | null
  }): void {
    running.value = next.running
    query.value = next.query
  }

  return { running, query, setPageRun }
})
